
// const host = "https://fixafibconnect.kiwicoder.com/api/v1";
// const fixafibhost = "https://fixafibconnect.kiwicoder.com/api/v1";
export const host = process.env.REACT_APP_API_URL || "http://localhost:7001/api/v1";
export const fixafibhost = process.env.REACT_APP_API_URL || "http://localhost:7001/api/v1";
//const host = "https://837b-182-180-118-76.ngrok-free.app"


/////////AUTHENTICATION//////////////////////
export const signUpRoute = `${host}/invites/verify-code`;
export const resendInvitationRoute = `${host}/invites/resend-invite/`;
export const meRoute = `${host}/auth/who-am-i`;
export const verifyAndUpdateRoute = `${host}/invites/accept-invite`;
export const loginRoute = `${host}/auth/login`;
export const forgetPasswordRoute = `${host}/auth/forgot-password/`;
export const verifyOTPRoute = `${host}/auth/verify-forget-password-otp/`;
export const changeForgetPasswordRoute = `${host}/auth/change-forget-password/`;
export const resendOTPRoute = `${host}/auth/resend-otp/`;
export const mySettingsRoute = `${host}/settings/my-settings`;
export const updateSettingsRoute = `${host}/settings/preferences`;
export const consentStatusRoute = `${host}/settings/consent-status`;
export const acceptConsentsRoute = `${host}/settings/accept-consents`;
export const changeLocationRoute = `${host}/users/me/switch-location`;

/////////PATIENTS//////////////////////////
export const patientsRoute = `${fixafibhost}/patients`;
export const patientByIdRoute = `${fixafibhost}/patients`;
export const patientActivityLogsRoute = `${fixafibhost}/patients`;
// export const createPatientRoute = `${host}/patients/create`;
// export const updatePatientRoute = `${host}/patients/update/`;
// export const deletePatientRoute = `${host}/patients/archive/`;
// export const getPatientRoute = `${host}/patients/`;

// Other Fixafib Routes
export const insurancesRoute = `${fixafibhost}/insurances`;
export const indicationsRoute = `${fixafibhost}/indications`;
export const specialtiesRoute = `${fixafibhost}/specialties`;
export const providersRoute = `${fixafibhost}/providers`;
export const contactsRoute = `${fixafibhost}/contacts`;
export const devicesRoute = `${fixafibhost}/devices`;
export const complicationsRoute = `${fixafibhost}/complications`;
export const trialParticipationsRoute = `${fixafibhost}/trial-participations`;
export const medicationsRoute = `${fixafibhost}/medications`;
export const medicationHoldInstructionsRoute = `${fixafibhost}/medication-hold-instructions`;
export const medicationFrequenciesRoute = `${fixafibhost}/medication-frequencies`;
export const medicationHoldTimingsRoute = `${fixafibhost}/medication-hold-timings`;
export const centerLocationsRoute = `${fixafibhost}/center-locations`;
export const messagesRoute = `${fixafibhost}/messages`;
export const messagesSendRoute = (id) => `${fixafibhost}/messages/${id}/send`;
export const messagesThreadsListRoute = `${fixafibhost}/messages/threads/list`;
export const messagesThreadRoute = (threadId) => `${fixafibhost}/messages/threads/${threadId}`;
export const messagesSendRescheduleOptionsRoute = (threadId) => `${fixafibhost}/messages/threads/${threadId}/send-reschedule-options`;
export const messagesUnreadCountRoute = `${fixafibhost}/messages/unread-count`;
export const messagesThreadMarkReadRoute = (threadId) => `${fixafibhost}/messages/threads/${threadId}/mark-read`;
export const messagesMessageMarkReadRoute = (id) => `${fixafibhost}/messages/${id}/mark-read`;
export const messagesVapiCallRoute = `${fixafibhost}/messages/vapi/call`;
export const messagesVapiCallsListRoute = `${fixafibhost}/messages/vapi/calls`;
export const messagesVapiCallByIdRoute = (callId) => `${fixafibhost}/messages/vapi/call/${callId}`;
export const vapiCallsRoute = `${fixafibhost}/calls`;
export const vapiCallByIdRoute = (id) => `${fixafibhost}/calls/${id}`;
export const vapiCallLogsRoute = (id) => `${fixafibhost}/calls/${id}/call-logs`;
export const vapiCallRescheduleOptionsRoute = (id) => `${fixafibhost}/calls/${id}/reschedule-options`;
export const messageTemplatesRoute = `${fixafibhost}/message-templates`;
export const messageTemplatesCommunicationRoute = `${fixafibhost}/message-templates/communication`;
export const messageTemplatesAllowedPlaceholdersRoute = `${fixafibhost}/message-templates/allowed-placeholders`;
export const emailTemplatesRoute = `${fixafibhost}/email-templates`;
export const emailTemplatesCommunicationRoute = `${fixafibhost}/email-templates/communication`;
export const emailTemplatesAllowedPlaceholdersRoute = `${fixafibhost}/email-templates/allowed-placeholders`;
export const contactDropdownFiltersApiRoute = `${fixafibhost}/contact-dropdown-filters`;
export const subjectAccessRequestsRoute = `${fixafibhost}/subject-access-requests`;
export const subjectAccessRequestsPublicRoute = `${fixafibhost}/subject-access-requests/public`;
export const subjectAccessRequestsPublicCentersRoute = `${fixafibhost}/subject-access-requests/public/centers`;
export const subjectAccessRequestsExportRoute = `${fixafibhost}/subject-access-requests/export`;
export const subjectAccessRequestsPatientMatchesRoute = `${fixafibhost}/subject-access-requests/patient-matches`;
export const subjectAccessRequestsAssignableUsersRoute = (id) =>
  `${fixafibhost}/subject-access-requests/${id}/assignable-users`;
export const subjectAccessRequestsFulfillmentPackageRoute = (id) =>
  `${fixafibhost}/subject-access-requests/${id}/fulfillment-package`;
export const subjectAccessRequestsSendFulfillmentEmailRoute = (id) =>
  `${fixafibhost}/subject-access-requests/${id}/send-fulfillment-email`;
export const locationCommunicationModesRoute = (locationId) =>
  `${fixafibhost}/locations/${locationId}/communication-modes`;

/////////CENTERS//////////////////////////
export const centersRoute = `${fixafibhost}/locations`;
export const centersDropdownRoute = `${fixafibhost}/locations/dropdown`;
/////////USERSROLES//////////////////////////
export const usersAPIRoute = `${host}/users`;
export const rolesAPIRoute = `${host}/roles`;
export const userRolesAPIRoute = `${host}/users/roles`;
export const creatUserRoute = `${host}/users/create-user`;
export const createMemberRoute = `${host}/users/create-member`;
export const updateProfileRoute = `${host}/users/update/`;
export const updateMyProfileRoute = `${host}/users/me/profile`;
export const updateDeviceIdRoute = `${host}/users/update-device-ids/`;
export const updatePasswordRoute = `${host}/auth/change-password/`;
export const editUserRoute = `${host}/users/update-user/`;
export const deleteUserRoute = `${host}/users/archive/`;
export const getAllUsersRoute = `${host}/users/`;
export const getAllRolesRoute = `${host}/roles/`;
export const getAllGroupsRoute = `${host}/groups/`;
export const updateGroupRoute = `${host}/groups/update/`;
export const createGroupsRoute = `${host}/groups/create/`;
export const deleteGroupRoute = `${host}/groups/archive/`;
export const createRoleRoute = `${host}/roles/create`;
export const updateRoleRoute = `${host}/roles/update/`;
export const updateDeletedRoleRoute = `${host}/roles/update-deleted/`;
export const deleteRoleRoute = `${host}/roles/archive/`;
export const getNotMemberUsers = `${host}/users/get-not-memeber-users`;
export const getVendorMemberUsers = `${host}/users/get-vendor-members`;
export const createBulkUsersRoute = `${host}/users/create-bulk-users`;
////////DASHBOARD//////////////////////////////
export const memberCountRoute = `${host}/dashboard/members-count-stats`;
export const offerCountRoute = `${host}/dashboard/offers-count-stats`;
export const offerQuarterlyRoute = `${host}/dashboard/offers-quarterly-stats`;
export const offerAvailedRoute = `${host}/dashboard/transaction-count-stats`;
export const availedWeeklyRoute = `${host}/dashboard/transaction-weekly-stats`;
export const availedMonthlyRoute = `${host}/dashboard/transaction-monthly-stats`;
export const offerAvailedTypeRoute = `${host}/dashboard/offers-type-stats`;
export const availedOffersProjectsRoute = `${host}/dashboard/most-availed-offers-stats`;
export const customerSegmentationRoute = `${host}/dashboard/customer-segmentation`;
export const topAvailedCitiesRoute = `${host}/dashboard/city-transaction-stats`;
export const revenueGrowthRoute = `${host}/dashboard/revenue-growth`;
export const averageTransactionValueRoute = `${host}/dashboard/average-transaction-value`;
////////REPORTING//////////////////////////////
export const reportingMembersRoute = `${host}/reporting/members-report`;
export const transactionsRoute = `${host}/reporting/transactions-report`;
export const reportingOffersRoute = `${host}/reporting/offers-report`;
////////AWS////////////////////////////////////
export const profilePutSignedURLRoute = `${host}/files/get-signed-url`;
export const profileGetSignedURLRoute = `${host}/files/get-preview-signed-url`;
export const getSignedURLWithVariantRoute = `${host}/files/get-preview-signed-url-variant`;
export const getMultiSignedURLRoute = `${host}/files/get-multiple-preview-signed-urls`;
export const getMultipleVariantSignedURLRoute = `${host}/files/get-multivariant-preview-signed-urls`;

////////AVATAR SPECIFIC////////////////////////////
export const avatarUploadUrlRoute = `${host}/users/me/avatar/upload-url`;
export const updateAvatarRoute = `${host}/users/me/avatar`;
export const deleteAvatarRoute = `${host}/users/me/avatar`;
export const s3DownloadUrlRoute = `${host}/s3/download-url`;
export const avatarDirectUploadRoute = `${host}/users/me/avatar/upload`;

////////LOGO UPLOAD////////////////////////////
export const logoUploadUrlRoute = `${host}/locations/logo/upload-url`;
export const logoFinalizeRoute = `${host}/locations`; // Will be used as `/locations/{id}/logo/finalize`
///////PROJECTS///////////////////////////////
export const getAllTagsRoute = `${host}/tags`;
export const createTagRoute = `${host}/tags/create`;
export const createProjectsRoute = `${host}/projects/create`;
export const deleteProjectRoute = `${host}/projects/`;
export const getProjectRoute = `${host}/projects/`;
export const getAllProjectsRoute = `${host}/projects/filtered/`;
export const getAllUnfilteredProjectsRoute = `${host}/projects/`;
export const getProjectManagerUsersRoute = `${host}/users/get-project-manager-users`;
///////LOYALTYMEMBERS/////////////////////////
export const getAllMemberGroups = `${host}/member-groups/`;
export const getAllTiers = `${host}/member-groups/tier-names`;
export const getAllPrintingJobs = `${host}/cards-printing`;
export const createPrintingJob = `${host}/loyalty-cards/print-cards`;
export const createMemberGroup = `${host}/member-groups/create`;
export const patchMemberGroup = `${host}/member-groups/`;
export const deleteMemberGroup = `${host}/member-groups/`;
export const projectMembersRoute = `${host}/members/in-project/`;
export const notProjectMembersRoute = `${host}/members/not-in-project/`;
export const createCardTemplateRoute = `${host}/card-templates/create-card-template/`;
export const getCardTemplatesRoute = `${host}/card-templates/`;
export const updateProjectMembersRoute = `${host}/projects/add-remove-project-members/`;
export const updateTierMembersRoute = `${host}/member-groups/add-remove-members/`;
export const tierMembersRoute = `${host}/members/in-group/`;
export const notTierMembersRoute = `${host}/members/not-in-group/`;
export const getLoyaltyCardsRoute = `${host}/loyalty-cards/`;
export const deleteTemplateRoute = `${getLoyaltyCardsRoute}archive-card-template/`;
export const updateBulkCardsRoute = `${host}/loyalty-cards/update-templates`;
export const getMembersRoute = `${host}/members/`;
export const bulkUpdateTiersRoute = `${host}/member-groups/bulk-update`;
export const getBulkTierDataRoute = `${host}/member-groups/get-bulk-data`;
export const getBulkUpdateTiersRoute = `${host}/member-groups/get-bulk-data`;
export const getMemberChildsRoute = `${host}/members/get-member-childs/`;
/////////OFFERS/////////////////////////////////
export const getAllOffersRoute = `${host}/offers/filtered/`;
export const getAllOffersUnfilteredRoute = `${host}/offers/`;
export const createOfferRoute = `${host}/offers/create-offer`;
export const projectVendorsRoute = `${host}/project-vendors/vendors`;
///////VENDORS/////////////////////////////////
export const createVendorRoute = `${host}/vendors/`;
export const createVendorMemberRoute = `${host}/vendors/create-vendor-member`;
export const getAllVendorsRoute = `${host}/vendors/filtered/`;
export const getAllVendorsUnfilteredRoute = `${host}/vendors/`;
export const getBulkVendorsRoute = `${host}/vendors/only-vendors-data`;
export const vendorBulkUpdateRoute = `${host}/vendors/bulk-update`;
export const getVendorManagersRoute = `${host}/users/get-vendor-managers`;
export const getVendorManagerUsersRoute = `${host}/users/get-vendor-manager-users`;
/////CAMPAIGNS/////////////////////////////////
export const getAllCampaignsRoute = `${host}/campaigns/`;
export const deleteCampaignRoute = `${host}/campaigns/archive`;
export const createCampaignRoute = `${host}/campaigns/create-campaign`;
/////EVENTS/////////////////////////////////////
export const getAllEventsRoute = `${host}/events/`;
export const deleteEventRoute = `${host}/events/archive`;
export const createEventRoute = `${host}/events/create-event`;
//////NOTIFICATIONS////////////////////////////
export const sendNotificationRoute = `${host}/notifications/`;
export const readNotificationRoute = `${host}/notifications/read-notifications`;
export const readOneNotificationRoute = `${host}/notifications/read-single-notification`;
export const emailNotificationRoute = `${host}/notifications/email-notifications`;
export const markAsReadNotificationRoute = `${host}/notifications/mark-read`;
export const markAllAsReadNotificationRoute = `${host}/notifications/mark-all-read`;
///////SETTINGS////////////
export const getCacRoute = `${host}/settings`;
export const getClientSettingsRoute = `${host}/client-settings`;
export const updateFreePlanRoute = `${host}/client-settings/free-plan`;
export const updateCacRoute = `${host}/settings`;
export const logoutRoute = `${host}/auth/logout`;
///////MODERATIONS////////////
export const projectModerationsRoute = `${host}/projects/moderations`;
export const approveRejectModerationRoute = `${host}/moderations`;
export const vendorModerationsRoute = `${host}/vendors/moderations`;
export const offerModerationsRoute = `${host}/offers/moderations`;
export const eventModerationsRoute = `${host}/events/moderations`;
export const projectModerationHistoryRoute = `${host}/projects/moderation-history`;
export const vendorModerationHistoryRoute = `${host}/vendors/moderation-history`;
export const offerModerationHistoryRoute = `${host}/offers/moderation-history`;
export const eventModerationHistoryRoute = `${host}/events/moderation-history`;
export const getModerators = `${host}/users/moderators`;
export const getModeratorCount = `${host}/users/moderatorCount`;
///////CLIENTS////////////
export const getClientsRoute = `${host}/users/clients-active`;
export const getAllClientsRoute = `${host}/users/clients`;
export const inviteClientRoute = `${host}/users/create-client`;
export const deleteClientRoute = `${host}/users/archive-client/`;
export const editClientRoute = `${host}/users/update-client/`;
///////SUBSCRIPTIONS///////
export const checkoutSessionRoute = `${host}/subscription/session/`;
export const getSubscriptionRoute = `${host}/subscription/data/`;
export const calculateNewRateRoute = `${host}/subscription/calculate`;
export const applyNewRateRoute = `${host}/subscription/apply-new-rate`;
export const cancelSubscriptionRoute = `${host}/subscription/cancel`;
export const getModulesRoute = `${host}/modules/`;
///////PLANS///////////////////
export const getAllPlans = `${host}/plans/all-active-plans`;
export const getPlans = `${host}/plans/all-plans`;
export const createPlanRoute = `${host}/plans/create`;
export const editPlanRoute = `${host}/plans/edit/`;
///////PAYMENTS////////////////////
export const getAllPayments = `${host}/payment-history/`;

/////////TASKS//////////////////////////
export const tasksRoute = `${fixafibhost}/tasks`;

/////////REMINDERS//////////////////////////
export const remindersRoute = `${fixafibhost}/reminders`;

/////////CASES//////////////////////////
export const casesRoute = `${fixafibhost}/cases`;
